export const Role = {
    User: 'User',
    Assign: 'assign_user',
}